var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1 5.4L9.6 0.6C8.7 -0.2 7.4 -0.2 6.5 0.6L0.9 5.4C0.3 5.9 0 6.6 0 7.3V14.5C0 15.3 0.7 16 1.5 16H14.5C15.3 16 16 15.3 16 14.5V7.3C16 6.6 15.7 5.9 15.1 5.4ZM1 7.5L4.8 10.8L1 14.2V7.5ZM8 9.3H7.9L1.4 15H14.4L8 9.3ZM11.2 10.8L15 7.5V14.2L11.2 10.8ZM7.1 1.3L1.5 6.1L1.2 6.4L5.5 10.2L7.3 8.6C7.7 8.3 8.3 8.3 8.7 8.6L10.5 10.1L14.8 6.4L14.5 6.1L8.9 1.3C8.7 1.1 8.3 1 8 1C7.7 1 7.3 1.1 7.1 1.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.787b2bf97d94ed816bc87e2e56951e71.svg";
export { ForwardRef as ReactComponent };